import { Helmet } from "react-helmet";
import AnimalGrid from "components/animalgrid";
import BodyText from "components/bodytext";
import ContentBox from "components/contentbox";
import HeaderText from "components/headertext";
import PageGallery from "components/pagegallery";
import Image from "components/image";
import Video from "components/video";

import ebt1 from "img/ebts/2018-06-15 16.10.34-1.jpg";
import ebt4 from "img/ebts/scan0027.jpg";
import collectionMeta from "content/collections/eastern-box-turtle.json";
import { animalGridFromJson } from "hooks/useGallery";
// Blaze

// Chili
// Egypt
// Shelly
// Turbo
// Yertle

const animalGridData = animalGridFromJson(collectionMeta);

const EasternBoxTurtle = () => {
  return (
    <ContentBox>
      <Helmet>
        <title>{collectionMeta.commonName}</title>
        <meta
          name="description"
          content="See the Eastern Box Turtles (Terrapene carolina carolina)
            that are being kept here and learn more about their captive husbandry."
        />
        <link rel="canonical" href="https://www.gcreptiles.com/eastern-box-turtle" />
      </Helmet>
      <HeaderText
        title={collectionMeta.commonName}
        subtitle={collectionMeta.scientificName}
      />
      <AnimalGrid data={animalGridData} />
      <BodyText>
        I was raised in Northern Virginia and was outdoors a lot as a kid so
        naturally I came in contact with Eastern Box turtles. I don't know if
        they are as prevalent in Fairfax County now as they were back in the 70s
        and 80s but we'd find several every year. One of our secret spots was
        actually a busy road that ran through a wooded area on the way to the
        big shopping mall in town. We called it "turtle road" because we saw
        many turtles trying to cross it. Sometimes we'd get out and catch one if
        Mom was in a good mood.
      </BodyText>
      <BodyText>
        I made a pen in the backyard of our house with chicken wire across the
        top and built a small pond and put a trio of box turtles inside. I had
        two males and a female and I would bring them inside and brumate them
        during the winter, although looking back on it I don't know why I did
        that. They probably would have done better outside. One summer I found a
        baby turtle in the pen which was my first time - if I can take any
        credit for it at all - breeding reptiles in captivity.
      </BodyText>
      <Image
        src={ebt4}
        caption="1979, family photo with an Eastern Box turtle keeping everyone happy"
      />
      <BodyText>
        There was a classic family moment once when we were taking our first and
        only professional family portrait in the backyard. The photographer got
        setup with his camera on a tripod and everyone got in position except
        for my younger brother Mark. Mark was crying and wanted nothing to do
        with being in the picture. Finally, to get him to submit, my parents
        allowed him to be in the photo holding one of the turtles we kept in the
        outdoor pen behind us. That turned into one of the most iconic family
        photos of my childhood.
      </BodyText>
      <Video
        src="https://www.youtube.com/embed/GHCYqOYAtqI"
        caption="How to Build an Indoor Turtle Habitat"
      />
      <BodyText>
        In my adult years I've looked for captive bred Eastern Box turtles and
        was surprised when someone local to me announced that he had a group he
        wanted to sell, although these are definitely not captive bred animals.
        I hurried and bought all of them. The group was male heavy so I replaced
        two of the males with a female that I found online so now I have 2.2.
      </BodyText>
      <Image
        src={ebt1}
        caption="2018, finishing off the extras from my son's wedding reception"
      />
      <BodyText>
        I keep them inside year-round but I need to find a way to move them
        outside for 8 or 9 months of the year. I built an outdoor enclosure when
        I first got them but after using it for a few months I found that it was
        just too hot for them no matter what I did to try and shade them from
        the harsh Utah summertime heat. Hopefully I can find another location
        outdoors where they can thrive.
      </BodyText>
      <BodyText>
        Like everything else I keep, I was hoping that I'd be successful
        breeding them. The older female has produced eggs several times but
        either I can't incubate them correctly or they just weren't fertile. I
        think at this point I won't try and incubate them artificially any more.
      </BodyText>
      <PageGallery slug="eastern-box-turtle" maxWidth="900" />
    </ContentBox>
  );
};

export default EasternBoxTurtle;
